import { render } from "./new.vue?vue&type=template&id=53013486"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "./new.vue?vue&type=style&index=0&id=53013486&lang=css"
script.render = render

export default script